/**
 * localStorage 工具类 - 维他抽奖活动
 * 用于持久化中奖状态和活动数据
 */

/**
 * 存储键枚举
 * 命名规范：vitasoy_lottery_2512_{功能}_{可选标识}
 */
export enum StorageKey {
  /** 参与活动标记*/
  LotteryJoin = 'vitasoy_lottery_2512_join'
}

/**
 * 设置中奖状态
 * @param cdkey 抽奖码
 * @param result 抽奖结果（可选）
 * @returns boolean - 是否设置成功
 */
export const setLotteryStatus = (cdkey: string): boolean => {
  if (!cdkey) {
    console.warn('[Storage] setLotteryStatus: cdkey is empty');
    return false;
  }

  try {
    // 标记中奖状态
    localStorage.setItem(StorageKey.LotteryJoin, 'true');
    return true;
  } catch (error) {
    // 处理 QuotaExceededError
    if (error instanceof Error && error.name === 'QuotaExceededError') {
      console.error('[Storage] localStorage quota exceeded');
    } else {
      console.error('[Storage] setLotteryStatus failed:', error);
    }
    return false;
  }
};

/** 是否参与过抽奖活动 */
export const hasJoinLottery = () => {
  try {
    const status = localStorage.getItem(StorageKey.LotteryJoin);
    return status === 'true';
  } catch (error) {
    console.error('[Storage] getHasJoinLottery failed:', error);
    return false;
  }
};

